import { useEffect, useState } from "react";
import { Sun, Menu, X, ArrowRight } from "lucide-react";

const NAV = [
  { id: "problem", label: "Problem" },
  { id: "co-robimy", label: "Co robimy" },
  { id: "jak-to-dziala", label: "Jak to działa" },
  { id: "pakiety", label: "Pakiety" },
  { id: "demo", label: "Demo" },
];

export default function AgencyHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToForm = () => {
    const el = document.getElementById("kontakt");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setMobileOpen(false);
  };

  return (
    <header
      data-testid="agency-header"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-[#0B0F1A]/85 backdrop-blur-md border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10 h-16 lg:h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 group" data-testid="agency-logo">
          <span className="grid place-items-center h-9 w-9 rounded-full bg-brand-yellow text-brand-yellowFg shadow-sm group-hover:rotate-12 transition-transform">
            <Sun strokeWidth={2.4} className="h-5 w-5" />
          </span>
          <span className="font-heading font-extrabold text-xl tracking-tight text-white">
            Heliora
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              className="text-sm font-medium text-white/70 hover:text-white transition-colors"
              data-testid={`agency-nav-${l.id}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            onClick={scrollToForm}
            data-testid="agency-header-cta"
            className="hidden sm:inline-flex items-center h-11 rounded-full bg-brand-yellow hover:bg-brand-yellowHover text-brand-yellowFg font-semibold px-5 shadow-md hover:shadow-lg hover:scale-[1.02] active:scale-95 transition-all"
          >
            Umów rozmowę
            <ArrowRight className="ml-1.5 h-4 w-4" />
          </button>
          <button
            type="button"
            onClick={() => setMobileOpen((v) => !v)}
            className="lg:hidden inline-flex h-10 w-10 items-center justify-center rounded-full text-white hover:bg-white/10"
            aria-label="Menu"
            data-testid="agency-mobile-menu-toggle"
          >
            {mobileOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden border-t border-white/10 bg-[#0B0F1A]" data-testid="agency-mobile-menu">
          <div className="px-5 py-4 flex flex-col gap-1">
            {NAV.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={() => setMobileOpen(false)}
                className="px-3 py-3 rounded-xl text-base font-medium text-white/85 hover:bg-white/5"
              >
                {l.label}
              </a>
            ))}
            <button
              onClick={scrollToForm}
              data-testid="agency-mobile-cta"
              className="mt-2 h-12 rounded-full bg-brand-yellow hover:bg-brand-yellowHover text-brand-yellowFg font-semibold inline-flex items-center justify-center"
            >
              Umów rozmowę
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
